"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopyBackward = void 0;
var getNestedValuesByPath_1 = require("./getNestedValuesByPath");
var deepCopyBackward = function (state, path, lastValue) {
    var _a;
    var recursiveObjectBackward = lastValue;
    for (var i = path.length - 1; i >= 0; i--) {
        var nestedValues = getNestedValuesByPath_1.getNestedValuesByPath(state, path.slice(0, i));
        recursiveObjectBackward = __assign(__assign({}, nestedValues), (_a = {}, _a[path[i]] = recursiveObjectBackward, _a));
    }
    return recursiveObjectBackward;
};
exports.deepCopyBackward = deepCopyBackward;
//# sourceMappingURL=deepCopyBackward.js.map